function listCacheHas(s){return assocIndexOf(this.__data__,s)>-1}var assocIndexOf=require("./_assocIndexOf");module.exports=listCacheHas;